<app-modal [dismissible]="false" class="popup-info">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <p>{{ infoMessage }}</p>
        <p>{{ detailsMessage }} </p>
        <p>{{ actionMessage }}</p>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="onCancel()"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
    </div>
</app-modal>
